import { useGetUserCapacityDataQuery } from '../../../__generated__/chirp/com/hubspot/cv/assignments/rpc/UserCapacityLimitsV2Service.hooks';
import { useMemo } from 'react';
import { useHasCapacityLimitsV2ReadScope } from '../../auth/hooks/useScopes';
import { getUserCapacityData, defaultLimitToInfinity } from '../utils/capacityUtils';
import { useGetCurrentUserCapacityDataRpc } from './useGetCurrentUserCapacityDataRpc';
import { useRealtimeUserLevelCapacityLimits } from './useRealtimeUserLevelCapacityLimits';
export const useDeprecatedUserLevelCapacityLimits = agentId => {
  const hasCapacityLimitsV2ReadScope = useHasCapacityLimitsV2ReadScope();
  const {
    data,
    loading
  } = useGetUserCapacityDataQuery({
    skip: !hasCapacityLimitsV2ReadScope,
    variables: {
      userId: agentId
    }
  });
  const capacityLimits = useMemo(() => {
    if (!data) {
      return;
    }
    return defaultLimitToInfinity(data.totalTicketUserCapacityData);
  }, [data]);
  return {
    capacityLimits,
    loading
  };
};

/**
 * This will pick out the configured capacity limits/loads for the authed user
 * based on the capacity configuration type, TOTAL or BY_CAPACITY_CATEGORY.
 * @returns capacity limits/loads object if TOTAL, or multiple objects for each category if BY_CAPACITY_CATEGORY.
 */
export const useCurrentUserCapacityLimits = () => {
  const {
    currentUserCapacity,
    loading,
    error
  } = useGetCurrentUserCapacityDataRpc();
  useRealtimeUserLevelCapacityLimits();
  if (!currentUserCapacity) {
    return {
      loading,
      error
    };
  }
  return {
    capacity: getUserCapacityData(currentUserCapacity),
    loading,
    error
  };
};